import React, { Component } from 'react';
import {Slider } from '@alife/next';
import CommonModal from '../CommonModal';
import map from './map';
import './index.css';

class IncubatorDetailServer extends Component {
  constructor(props){
    super(props);
    this.state={
      parkId:0,
      start:false,
      end:true,
      itemNodesBoxPC:null,
      itemNodesBoxH5:null
    };
  }

  componentWillMount(){
    let parkId = window.location.href.split('detail/')[1].split('/')[0].replace('#','');
    parkId = parkId.indexOf('?')>0?parkId.split('?')[0]:parkId;
    this.props.queryParkInfo(parkId);
    this.setState({
      parkId:parkId
    });
  }

  componentWillUpdate(newProps){
    if(this.props === newProps) return;
    let policy = newProps.parkBaseInfoVO.policy.replace(/\n/g,'<br />');
    document.getElementById('incubator_policy').innerHTML = policy;
    map(newProps.parkBaseInfoVO.location.split(','));
  }

  beforeChange = (currentIndex,nextIndex) => {
    let index = this.props.parkMediaExtInfoVOList.length==3?1:4;
    document.querySelectorAll('.slider-img-wrapper')[nextIndex+index].style.opacity=1;
    document.querySelectorAll('.slider-img-wrapper')[currentIndex+index].style.opacity=0.6;
  }

  compare = (property) => {
    return function(obj1,obj2){
      let value1 = obj1[property];
      let value2 = obj2[property];
      return value1 - value2; 
    };
  }
  render(){
    let {parkMediaExtInfoVOList} =this.props;
    const settingsPC = {
      className: 'custom-slide',
      arrowPos: 'inline',
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      pauseOnHover: true,
      arrowSize:'large',
      arrows:true
    };
    const settingsH5 = {
      className: 'custom-slide',
      arrowPos: 'inline',
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      pauseOnHover: true,
      arrowSize:'large',
      arrows:true
    };
    let res = [];
    if(parkMediaExtInfoVOList.length>=3){
      let sortList = parkMediaExtInfoVOList.sort(this.compare('idxNum'));
      sortList.map((item, index) =>{
        let videoTrigger = (
          <div className='video-trigger-item'>
            <img src={`${window.GLOBAL_CONFIG.image_host}/${item.thumbnail}`} />
            <img src={require('../../../lib/images/play-icon.png')} className='play-icon'/>
          </div>
        );
        if(item.type==='img'){
          res.push(<div key={index} className={sortList.length==3?'slider-img-wrapper':'slider-img-wrapper len'}>
            <CommonModal trigger={<img src={`${window.GLOBAL_CONFIG.image_host}/${item.url}`} />}>
              <img src={`${window.GLOBAL_CONFIG.image_host}/${item.url}`} />
            </CommonModal>
          </div>);
        }else{
          res.push(<div key={index} className={sortList.length==3?'slider-img-wrapper':'slider-img-wrapper len'}>
            <CommonModal trigger={videoTrigger}>
              <video
                src={`${window.GLOBAL_CONFIG.video_host}/${item.url}`}
                controls={true}
                preload={'auto'}
                autoPlay={false}
              />
            </CommonModal>
          </div>);
        }     
      });
    }
    let itemNodesBoxPC = <Slider {...settingsPC} infinite={true} beforeChange={this.beforeChange}>{res}</Slider>;
    let itemNodesBoxH5 = <Slider {...settingsH5} infinite={true} beforeChange={this.beforeChange}>{res}</Slider>;
    return(
      <div>
        <div className='detail_show_main_box'>
          <div className='detail_show_title'>
            <div className='introduction_title'>园区展示</div>
          </div>
        </div>
        <div className='show_main_images innerPC'>
          {itemNodesBoxPC}
        </div>
        <div className='show_main_images innerH5'>
          {itemNodesBoxH5}
        </div>
      </div>
    );
  }
}

export default IncubatorDetailServer;


// WEBPACK FOOTER //
// ./src/scripts/components/Incubator/IncubatorDetailServer/index.js